import React, { Component } from 'react'
import { connect } from 'cerebral-view-react'
import Login from './login'
import Registration from './registration'
import RegistrationDone from './registrationDone'
import ForgotPassword from './forgotPassword'
import RestorePassword from './restorePassword'
import Device from './helper/device'
import Dialog from '../common/dialog/GDPR'

class RegistrationContainer extends Component {
  renderCurrent() {
    const { currentPage } = this.props
    switch (currentPage) {
      case 'common':
      case 'delivery':
      case 'invoice':
      case 'visiting':
        return <Registration currentPage={currentPage} />
      case 'done':
        return <RegistrationDone />
      case 'forgotPassword':
        return <ForgotPassword />
      case 'restorePassword':
        return <RestorePassword />
      default:
        return <Login />
    }
  }

  render() {
    const { logo, device } = this.props
    let machine = new Device(device)
    return (
      <div style={{ width: '100%', marginTop: 30 }}>
        <Dialog />
        <div style={{ textAlign: 'center', display: 'block' }}>
          <div
            style={{
              display: 'inline-block',
              position: 'relative',
              width: '100%'
            }}>
            <img
              src={logo}
              style={{
                border: 'none',
                maxWidth: 380,
                maxHeight: 300
              }}
              alt={''}
            />
          </div>
        </div>
        <div
          style={{
            paddingLeft: machine.getPadding(),
            paddingTop: machine.getPadding(),
            paddingRight: machine.getPadding()
          }}>
          {this.renderCurrent()}
        </div>
      </div>
    )
  }
}

export default connect({
  logo: 'client.logo',
  currentPage: 'client.currentPage',
  device: 'useragent.device.type'
})(RegistrationContainer)



// WEBPACK FOOTER //
// ./src/components/Login/registrationContainer.js